import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRouteConstants } from '../../../../../core/constants/api-routes';

@Injectable({
    providedIn: 'root',
})
export class ApplicationExportService {
    private readonly applicationApiRoute = ApiRouteConstants.Application;

    constructor(private readonly http: HttpClient) {}

    /**
     * Fetches the PDF for the given application as a Blob.
     */
    getPdf(applicationId: number): Observable<Blob> {
        const url = this.applicationApiRoute.getFullRouteWithApplicationId(
            'applicationExport',
            String(applicationId),
        );

        const headers = new HttpHeaders({ Accept: 'application/pdf' });

        return this.http.get(url, {
            headers,
            responseType: 'blob',
        });
    }
}
